import {
  ArrowLeftRight,
  BarChart3,
  Car,
  FileText,
  LayoutDashboard,
  LogOut,
  MapPin,
  Menu,
  Navigation,
  Send,
  X
} from 'lucide-react';
import { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { cn } from '../lib/utils';
import { Button } from './ui/button';
import brand from '../lib/brand';

const menuItems = [
  { key: '/', icon: LayoutDashboard, label: 'Хянах самбар' },
  { key: '/orders', icon: FileText, label: 'Захиалга' },
  { key: '/deliveries', icon: Send, label: 'Хүргэлт' },
  { key: '/transfers', icon: ArrowLeftRight, label: 'Шилжүүлэх' },
  { key: '/deer-report', icon: BarChart3, label: 'Тайлан' },
  { key: '/drivers', icon: Car, label: 'Хүргэлтийн ажилтнууд' },
  { key: '/locations', icon: Navigation, label: 'Байршил' },
  { key: '/districts', icon: MapPin, label: 'Дүүргүүд' },
];

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-zinc-50">
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      <aside className={cn(
        "fixed inset-y-0 left-0 z-50 w-64 bg-zinc-900 text-white flex flex-col transition-transform lg:translate-x-0 lg:static lg:z-auto",
        sidebarOpen ? "translate-x-0" : "-translate-x-full"
      )}>
        <div className="flex items-center justify-between p-4 border-b border-zinc-800">
          <span className="text-lg font-bold">{brand.name}</span>
          <button className="lg:hidden text-zinc-400 hover:text-white" onClick={() => setSidebarOpen(false)}>
            <X className="h-5 w-5" />
          </button>
        </div>

        <nav className="flex-1 p-2 space-y-1 overflow-y-auto">
          {menuItems.map(item => {
            const Icon = item.icon;
            const active = location.pathname === item.key;
            return (
              <button
                key={item.key}
                onClick={() => { navigate(item.key); setSidebarOpen(false); }}
                className={cn(
                  "flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm transition-colors",
                  active ? "bg-primary text-white" : "text-zinc-400 hover:text-white hover:bg-zinc-800"
                )}
              >
                <Icon className="h-4 w-4 shrink-0" />
                {item.label}
              </button>
            );
          })}
        </nav>

        <div className="p-2 border-t border-zinc-800">
          <button
            onClick={() => { logout(); navigate('/login'); }}
            className="flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm text-zinc-400 hover:text-white hover:bg-zinc-800 transition-colors"
          >
            <LogOut className="h-4 w-4" />
            Гарах
          </button>
        </div>
      </aside>

      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-14 bg-white border-b flex items-center justify-between px-4 sticky top-0 z-30">
          <Button variant="ghost" size="icon" className="lg:hidden" onClick={() => setSidebarOpen(true)}>
            <Menu className="h-5 w-5" />
          </Button>
          <div className="ml-auto text-sm text-zinc-600">{user?.name}</div>
        </header>
        <main className="flex-1 p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
